export default "__VITE_ASSET__a56b1fd6__"